export default __webpack_public_path__ + "770dfdd4cc6cae39ac99a8b5c14f93d2.svg";